import React from "react";

const FormInput = ({
  label,
  placeholder,
  required,
  type,
  hint,
  horizontal,
  value,
  onChange,
  error,
  defaultValue,
  disabled,
}) => {
  return (
    <div className={horizontal ? "row mb-3" : "mb-3"}>
      {label ? (
        <label
          className={
            required
              ? "form-label required"
              : horizontal
              ? "form-label col-3 col-form-label"
              : "form-label fw-medium"
          }
        >
          {label}
        </label>
      ) : null}
      <div className={horizontal ? "col" : null}>
        <input
          type={type}
          className={error ? "form-control is-invalid" : "form-control"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          defaultValue={defaultValue}
          disabled={disabled}
        />
        {hint ? <small className="form-hint">{hint}</small> : null}
        {error ? <div className="invalid-feedback">{error}</div> : null}
      </div>
    </div>
  );
};

export default FormInput;
